import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import ErrorIcon from '@mui/icons-material/Error';
import RemoveIcon from '@mui/icons-material/Remove';
import { Nothing } from 'components/general/Nothing';
import {
  removeIconSx,
  iconHeightSx,
  errorIconSx,
} from './styles';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';

export const innerIcon = {
  [ComplianceAnswerOption.unset]: <Nothing />,
  [ComplianceAnswerOption.notApplicable]: <RemoveIcon sx={removeIconSx} />,
  [ComplianceAnswerOption.notPassed]: <ClearIcon sx={iconHeightSx} />,
  [ComplianceAnswerOption.passed]: <CheckIcon sx={iconHeightSx} />,
};

export const errorIcon = <ErrorIcon sx={errorIconSx} />;
